import React, { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';
import { IconArrowLeft } from 'components/Icons';

import s from './BackToLocation.module.scss';

function BackToLocation() {
  const location = useLocation();
  const [returnURL, setReturnURL] = useState(null);
  const locations = [
    {
      url: 'https://midjan.landsvirkjun.is/',
      match: ['ferdabeidnir'],
      label: 'Midjan',
    },
    // ,
    // {
    //   url: 'https://midjan.landsvirkjun.is/umsysl',
    //   match: ['admin'],
    //   label: 'Umsjón beiðna á Miðjunni',
    // },
  ];

  const returnTo = () => {
    const path = location.pathname.split('/').filter((l) => l);
    const to = locations.filter((loc) => {
      return loc.match?.includes(...path);
    });
    return to[0];
  };

  useEffect(() => {
    setReturnURL(returnTo());
  }, [location]);

  if (!returnURL) return null;

  return (
    <div className={s.backToLocation}>
      <a href={returnURL.url} className={s.backToLocation__link}>
        <IconArrowLeft className={s.BackToLocation__icon} />
        {returnURL.label}
      </a>
    </div>
  );
}
export default BackToLocation;
